/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_UpdateSecFeeDto } from '../models/PagedResultDto_UpdateSecFeeDto';
import type { Wealthlane_AwardService_Dtos_Fee_CreateSecFeeDto } from '../models/Wealthlane_AwardService_Dtos_Fee_CreateSecFeeDto';
import type { Wealthlane_AwardService_Dtos_Fee_UpdateSecFeeDto } from '../models/Wealthlane_AwardService_Dtos_Fee_UpdateSecFeeDto';
import type { Wealthlane_Shared_Hosting_Dtos_GenericApiResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericApiResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class FeeService {

    /**
     * @param requestBody
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static postApiAwardApiAppFeeSecFee(
        requestBody?: Wealthlane_AwardService_Dtos_Fee_CreateSecFeeDto,
    ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/fee/sec-fee',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static putApiAwardApiAppFeeSecFee(
        requestBody?: Wealthlane_AwardService_Dtos_Fee_UpdateSecFeeDto,
    ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/fee/sec-fee',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static deleteApiAwardApiAppFeeSecFee(
        id: string,
    ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/award/api/app/fee/{id}/sec-fee',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param filter
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns PagedResultDto_UpdateSecFeeDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppFeeSecFeeList(
        filter?: string,
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<PagedResultDto_UpdateSecFeeDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/fee/sec-fee-list',
            query: {
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
